import Vue from 'vue';
import * as StoreTypes from '@/store/types';
import {errors} from '@/constants/errors';
import axios from 'axios';
// import {get} from '@/store/getters'
//export const BASE_URL = ;
export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:7034/api'
    : 'https://scms-platform.olympusmarinegroup.com:7034/api';
export const AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 235000,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': 'http://localhost',
    'Access-Control-Allow-Origin': 'https://scms-platform.olympusmarinegroup.com',
    'Access-Control-Allow-Credentials': true,
  },
});

AxiosInstance.interceptors.request.use(
  function (config) {
    let freeAPIUrls = ['/users/authenticate', '/users/refresh', '/users/forgotpassword'];

    const user = Vue.prototype.$store.getters.userDetails;
    let ActionUserId = null;

    if (freeAPIUrls.includes(config.url)) {
      return config;
    } else {
      if (!user.hasOwnProperty('data')) {
        let data: any = sessionStorage.getItem('user');
        const sessionUser = data ? JSON.parse(data) : null;
        if (sessionUser !== null) {
          ActionUserId = sessionUser.internalId;
        }
      } else {
        ActionUserId = user?.data?.internalId;
      }

      if (config.params === undefined || config.params === null) {
        // // config.params = !config.params.hashasOwnProperty("ActionUserId")? { ActionUserId: ActionUserId }:''
        config.params = {ActionUserId: ActionUserId};

        return config;
      } else {
        let params = config.params;
        params.ActionUserId = ActionUserId;

        return config;
      }
    }
  },
  function (err) {
    return Promise.reject(err);
  }
);

export function getAuthHeaders() {
  let token = sessionStorage.getItem('access_token');
  let headers = token ? {Authorization: `Bearer ${token}`} : null;
  return headers;
}

/*check if response has invalid session
  redirect to login
  */
export const validateUser = (response: any) => {
  const {error} = response.data;
  if (error && error.trim() === 'invalid_token') {
    sessionStorage.clear();
    Vue.prototype.$store.commit(StoreTypes.SET_LOGGED_IN, false);
    return false;
  }
  return true;
};

export const API = {
  //refresh login token
  async userRefreshToken() {
    let refreshToken = sessionStorage.getItem('refresh_token');
    if (refreshToken === null) {
      return false;
    }
    try {
      let response = await AxiosInstance.post('/users/refresh', {
        refreshtoken: refreshToken,
      });
      if (response.status === 200) {
        const res = response.data;
        const tokens = res.data;
        sessionStorage.setItem('access_token', tokens.access_token);
        sessionStorage.setItem('refresh_token', tokens.refresh_token);
        return true;
      }
    } catch (e) {
      return false;
    }
  },

  // ADMIN SECTION START FROM HERE
  //Admin login API
  async getLoginAuthentication(email: string, password: string) {
    try {
      let response = await AxiosInstance.post('/users/authenticate', {
        username: email,
        password: password,
      });
      if (response.status === 200) {
        sessionStorage.setItem('access_token', response.data.data.accessToken);
        sessionStorage.setItem('refresh_token', response.data.data.refreshToken);
        return response;
      }
    } catch (error) {
      return error.response;
    }
  },

  // USER API ENDPOINT START FROM HERE
  //Fetch user list
  async getUserList() {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.get('/users/list', {
        headers,
      });
      if (validateUser(response)) {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        return errors.tokenExpireError;
      }
    } catch (error) {
      return errors.networkError;
    }
  },
  async forgotPassword(email: string) {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.post('/users/forgotpassword', {Email: email}, {headers});
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async registerUser(
    name: string,
    email: string,
    isLoginEnable: boolean,
    enabled: boolean,
    password: string,
    groupId: string
  ) {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.post(
        `/users/register`,
        {
          FirstName: name,
          Email: email,
          Password: password,
          Enabled: enabled,
          IsLoginEnabled: isLoginEnable,
          Group_Id: groupId,
        },
        {
          headers,
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async getUserById(userId: any) {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.get(`/users/${userId}`, {
        headers,
      });
      if (validateUser(response)) {
        if (response.status === 200) {
          return response.data;
        }
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateUserById(
    userId: number,
    name: string,
    email: string,
    isLoginEnable: boolean,
    enabled: boolean,
    groupId: number
  ) {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.put(
        `/users/update/${userId}`,
        {
          FirstName: name,
          Email: email,
          Enabled: enabled,
          IsLoginEnabled: isLoginEnable,
          Group_Id: groupId,
        },
        {
          headers,
        }
      );
      if (validateUser(response)) {
        if (response.status === 200) {
          return response.data;
        }
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteUserById(userId: any) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.delete(`/users/delete/${userId}`, {
        headers,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async changePassword(userId: number, newPassword: string) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.put(
        `/users/changepassword/${userId}`,
        {
          password: newPassword,
        },
        {
          headers,
        }
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  // Client API START FROM HERE

  async getClientList() {
    try {
      let response = await AxiosInstance.get(`/client/list`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateClientDetails(
    clientId: number,
    name: string,
    email: string,
    phone: number,
    webpage: string,
    postalCode: number,
    address: string,
    comment: string
  ) {
    try {
      let response = await AxiosInstance.put(`/client/update/${clientId}`, {
        Name: name,
        Email: email,
        Phone: phone,
        Webpage: webpage,
        postalcode: postalCode,
        Address: address,
        Comment: comment,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createClient(
    name: string,
    email: string,
    phone: number,
    webpage: string,
    postalCode: number,
    address: string,
    comment: string
  ) {
    try {
      let response = await AxiosInstance.post(`/client/create`, {
        Name: name,
        Email: email,
        Phone: phone,
        Webpage: webpage,
        postalcode: postalCode,
        Address: address,
        Comment: comment,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //SHIP API SECTION START FROM HERE

  async getShipList() {
    try {
      let response = await AxiosInstance.get(`/ship/list`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async getShipDetailsById(shipId: number) {
    try {
      let response = await AxiosInstance.get(`/ship/${shipId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //LOGO ENDPOINT START FROM HERE
  async getLogoList() {
    try {
      let response = await AxiosInstance.get(`/admin/logos`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createLogo(data) {
    try {
      let response = await AxiosInstance.post(`/admin/logo/create`, {
        ...data,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async getLogoDetailsById(logoId: string) {
    try {
      let response = await AxiosInstance.get(`/admin/logo/${logoId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateLogoDetailsById(logoId: string, data: any) {
    try {
      let response = await AxiosInstance.put(`/admin/logo/update/${logoId}`, {
        ...data,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteLogoById(logoId: string) {
    try {
      let response = await AxiosInstance.delete(`/admin/logo/delete/${logoId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //NEWS ENDPOINTS START FROM HERE

  async fetchNewsList() {
    try {
      let response = await AxiosInstance.get(`/news/list`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchNewsDetailsById(newsId: number) {
    try {
      let response = await AxiosInstance.get(`/news/${newsId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createNews(params) {
    try {
      let response = await AxiosInstance.post(`/news/create`, {...params});

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateNews(newsId: string, params) {
    try {
      let response = await AxiosInstance.put(`/news/update/${newsId}`, {
        ...params,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteNewsById(newsId: number) {
    try {
      let response = await AxiosInstance.delete(`/news/delete/${newsId}`);

      if (response.status === 200) {
        return response;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //BACKGROUND IMAGE ENDPOINTS START FROM HERE

  async fetchBgImageList() {
    try {
      let response = await AxiosInstance.get(`/admin/images`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createBgImageDetails(imageName: string, imageUrl: string, imageStatus: boolean) {
    try {
      let response = await AxiosInstance.post(`/admin/image/create`, {
        bgimageisactive: imageStatus,
        bgimagename: imageName,
        bgimagepath: imageUrl,
      });

      if (response.status === 200) {
        //
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteBgImageById(bgImageId: number) {
    try {
      let response = await AxiosInstance.delete(`admin/image/delete/${bgImageId}`);

      if (response.status === 200) {
        return response;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchBgImageDetailsById(imageId: number) {
    try {
      let response = await AxiosInstance.get(`/admin/image/${imageId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateBgImageDetails(imageId: number, imageName: string, imageUrl: string, imageStatus: boolean) {
    try {
      let response = await AxiosInstance.put(`/admin/image/update/${imageId}`, {
        bgimageisactive: imageStatus,
        bgimagename: imageName,
        bgimagepath: imageUrl,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async activateOrDeactivateUser(recordId: number, recordEnableStatus: boolean, recordLoginStatus: boolean) {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.put(
        `/users/UpdateStatus/${recordId}`,
        {
          IsLoginEnabled: recordLoginStatus,
          Enabled: recordEnableStatus,
        },
        {
          headers,
        }
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  // ACTIVE/DEACTIVATE RECORDS

  async changeRecordStatus(source: string, recordId: number, recordUpdateStatus: boolean) {
    let switchResponse = this.getEndPointDetails(source);
    let endpoint = switchResponse.endpoint;
    let key = switchResponse.param;

    //
    try {
      let response = await AxiosInstance.put(`${endpoint}/${recordId}`, {
        [key]: recordUpdateStatus,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  getEndPointDetails(source: any) {
    let apiurl = {endpoint: '', param: ''};

    switch (source) {
      case 'logo': {
        apiurl.endpoint = '/admin/logo/update';
        apiurl.param = 'logoisactive';
        break;
      }

      case 'news': {
        apiurl.endpoint = '/news/update';
        apiurl.param = 'newsIsActive';
        break;
      }

      case 'bgimage': {
        apiurl.endpoint = '/admin/image/update';
        apiurl.param = 'bgimageisactive';
        break;
      }
    }
    return apiurl;
  },
  /*Milestone 2

  *****GLOBAL SETTINGS*****
  fetch global setting
  */
  async getGlobalSetting() {
    try {
      let response = await AxiosInstance.get(`/config/globalsettings/list`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async updateGlobalSetting(settingId, data) {
    try {
      let response = await AxiosInstance.put(`/config/globalsetting/update/${settingId}`, {
        ...data,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  //Email Config APIs
  async getEmailConfigList() {
    try {
      let response = await AxiosInstance.get(`/config/emailconfigs/list`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async getEmailConfigById(configId) {
    try {
      let response = await AxiosInstance.get(`/config/emailconfig/${configId}`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async createEmailConfig(data) {
    try {
      let response = await AxiosInstance.post(`/config/emailconfig/create`, {
        ...data,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async updateEmailConfig(id, data) {
    try {
      let response = await AxiosInstance.put(`/config/emailconfig/update/${id}`, {
        ...data,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createClass(formInput: any) {
    try {
      let response = await AxiosInstance.post(`/class/create`, {
        ...formInput,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchClassList() {
    try {
      let response = await AxiosInstance.get(`/class/list`);
      if (response.status === 200) return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteClassById(classId: any) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.delete(`/class/delete/${classId}`, {
        headers,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchClassInfoById(classId: any) {
    try {
      let response = await AxiosInstance.get(`/class/${classId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateClassInfoById(classId: any, formInput: any) {
    try {
      let response = await AxiosInstance.put(`/class/update/${classId}`, {
        ...formInput,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //ZONE APIs

  async fetchZoneList() {
    try {
      let response = await AxiosInstance.get(`/zones/list`);
      if (response.status === 200) return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchZoneInfoById(zoneId: string) {
    try {
      let response = await AxiosInstance.get(`/zones/${zoneId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async changeClassStatus(classId: number, status: boolean) {
    try {
      let response = await AxiosInstance.put(`/class/status/${classId}`, {
        isActive: status,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async changeZoneDeckStatus(zoneDeckId: string, status: boolean) {
    try {
      let response = await AxiosInstance.put(`/zones/master/status/${zoneDeckId}`, {
        isActive: status,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createZone(input: any) {
    try {
      let response = await AxiosInstance.post(`/zones/create`, {
        ...input,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async deleteZoneById(zoneId: any) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.delete(`zones/master/delete/${zoneId}`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchShipList() {
    try {
      let response = await AxiosInstance.get(`/ships/list`);

      if (response.status === 200) return response?.data;
    } catch (error) {
      return error?.response?.data;
    }
  },

  async fetchAllowedShipListForRole() {
    try {
      let response = await AxiosInstance.get(`/ships/listallowedshipsforrole`);

      if (response.status === 200) return response?.data;
    } catch (error) {
      return error?.response?.data;
    }
  },

  // async fetchDecksByShipId(shipId: number) {
  //   try {
  //     let response = await AxiosInstance.get(`/ships/${shipId}`);

  //     if (response.status === 200) return response.data;
  //   } catch (error) {
  //     return error.response.data;
  //   }
  // },

  async fetchEmptyDecksByShipId(params, shipId: number) {
    try {
      let response = await AxiosInstance.post(`/ships/${shipId}`, {
        ...params,
      });

      if (response.status === 200) return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  async updateZoneInfoById(zoneId: string, formInput: any) {
    try {
      let response = await AxiosInstance.put(`/zones/update/${zoneId}`, {
        ...formInput,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchCenterPointList() {
    try {
      let response = await AxiosInstance.get(`zones/centers/list`);
      if (response.status === 200) return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteCenterPointById(centerPointId: any) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.delete(`/zones/centers/delete/${centerPointId}`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createCenterPoint(formInput: any) {
    try {
      let response = await AxiosInstance.post(`/zones/centers/create`, {
        ...formInput,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchCenterPointInfoById(centerPointId: string) {
    try {
      let response = await AxiosInstance.get(`zones/centers/${centerPointId}`);

      if (response.status === 200) return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  // Delete Fram list
  async deleteFrameById(zoneId: any) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.delete(`zones/frames/delete/${zoneId}`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //Frame list APIs

  async fetchFrameList() {
    try {
      let response = await AxiosInstance.get(`/zones/frames/list`);
      if (response.status === 200) return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  // Create frame
  async createFrame(input: any) {
    try {
      let response = await AxiosInstance.post(`zones/frames/create`, {
        ...input,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //Fetch zone list by ship id
  async fetchZoneListByShipID(params, shipid: number) {
    try {
      let response = await AxiosInstance.post(`/zones/listbyship/${shipid}`, {
        ...params,
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  //Fetch frame details
  async fetchFrameDetailsBYId(id: string) {
    try {
      let response = await AxiosInstance.get(`/zones/frames/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  // Create frame
  async updateFrame(input: any) {
    try {
      let response = await AxiosInstance.put(`zones/frames/update/`, {
        ...input,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async updateCenterPointById(centerPointId: string, formInput: any) {
    try {
      let response = await AxiosInstance.put(`zones/centers/update/${centerPointId}`, {
        ...formInput,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async convertImgURLToBLob(imgURL: string) {
    try {
      const response = await axios.get(imgURL, {
        responseType: 'blob',
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  },

  async fetchShipDataById(shipId: number, params: any) {
    try {
      let response = await AxiosInstance.put(`ships/${shipId}`, {
        ...params,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateShipById(shipId: number, formInput: any) {
    try {
      let response = await AxiosInstance.put(`ships/update/${shipId}`, {
        ...formInput,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //get zones by deck id

  async fetchZonesByDeckId(drawingId: string) {
    try {
      let response = await AxiosInstance.post(`/zones/listbydeck/${drawingId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async fetchInspectionId(zoneDeckId: string) {
    try {
      let response = await AxiosInstance.get(`inspection/inspectionid/${zoneDeckId}`, {});

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async fetchReInspectionId(parentId: string) {
    try {
      let response = await AxiosInstance.get(`inspection/re/inspectionid/${parentId}`, {});

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchInspectionFindings() {
    try {
      let response = await AxiosInstance.get(`/inspection/findings`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchInspectionSeverity() {
    try {
      let response = await AxiosInstance.get(`/inspection/severity`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchInspectionVoyage(shipId: number, date: any) {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.get(`/inspection/voyage?shipId=${shipId}&InspectionDate=${date}`, {
        headers,
      });
      if (validateUser(response)) {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        return errors.tokenExpireError;
      }
    } catch (error) {
      return errors.networkError;
    }
  },

  async fetchInspectionCreators() {
    try {
      let response = await AxiosInstance.get(`/Users/GetUsersWithInspections`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response;
    }
  },

  async getInspectionList(param: object) {
    try {
      const response = await AxiosInstance.get('/inspection/list', {
        params: param,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  },

  async getInspectionListByShip(param: object) {
    try {
      const response = await AxiosInstance.get('/inspection/ListByShip', {
        params: param,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  },

  async deleteDeckById(deckId: string) {
    let headers = getAuthHeaders();
    try {
      let response = await AxiosInstance.delete(`/ships/deck/delete/${deckId}`);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async addOrUpdateDeck(params: any) {
    try {
      let response = await AxiosInstance.put(`/ships/deck/save`, {
        ...params,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async activateOrDeactivateShip(shipId: number, status: boolean) {
    try {
      let response = await AxiosInstance.put(`/ships/update/status/${shipId}`, {
        status: status,
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async snycShipsFromVOP() {
    try {
      let headers = getAuthHeaders();
      let response = await AxiosInstance.get(`/ship/sync`, {
        headers,
      });

      if (response?.status === 200) {
        return response?.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createInspection(params: any) {
    try {
      let response = await AxiosInstance.post(`/inspection/create`, {
        ...params,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async updateInspection(inspectionId: string, params: any) {
    try {
      let response = await AxiosInstance.put(`/inspection/update/${inspectionId}`, {
        ...params,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchVoyageConditions() {
    try {
      let response = await AxiosInstance.get(`inspection/voyageconditions`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchInspectionDataById(inspectionId: string) {
    try {
      let response = await AxiosInstance.get(`inspection/${inspectionId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  // http://10.0.20.80:8182/api/inspection/zonebyinspectionpoint?ShipId=3&DeckId=64&Location_X=1100

  async fetchInspectionPointOnDeck(shipId: number, deckId: number, locationX: number) {
    try {
      let response = await AxiosInstance.get(
        `/inspection/zonebyinspectionpoint?ShipId=${shipId}&DeckId=${deckId}&Location_X=${locationX}`
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteAttchamentById(attachmentId: string) {
    try {
      let response = await AxiosInstance.delete(`inspection/attachment/delete/${attachmentId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteInspectionById(inspectionId: string) {
    try {
      let response = await AxiosInstance.delete(`/inspection/delete/${inspectionId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async deleteEntireInspectionById(inspectionId: string) {
    try {
      let response = await AxiosInstance.delete(`/inspection/deleteall/${inspectionId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async createReInspection(params: any) {
    try {
      let response = await AxiosInstance.post(`/inspection/re/create`, {
        ...params,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async saveActionPlanData(params: any) {
    try {
      let response = await AxiosInstance.post(`/inspection/actionplan/save`, {
        ...params,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchActionPlanDataByInspectionId(inspectionId: string) {
    try {
      let response = await AxiosInstance.get(`/inspection/actionplanbyinspection/${inspectionId}`, {});
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchInspectionHistoryById(inspectionId: string) {
    try {
      let response = await AxiosInstance.get(`/inspection/list?InspectionId=${inspectionId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchInspecionById(inspectionId: string) {
    try {
      let response = await AxiosInstance.get(`/inspection/print/${inspectionId}`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchReportDataByFindings(params) {
    try {
      let response = await AxiosInstance.get(
        // `/Reports/InspectionByFindings?startDate=${params.startDate}&endDate=${params.endDate}&type&inspectionId&objDecks=${params.objDecks}&FrameFrom=${params.FrameFrom}&FrameUpto=${params.FrameUpto}&Inspectiontype=${params.Inspectiontype}&IsClosed=${params.IsClosed}&IsDeleted=${params.IsDeleted}&IsMisc=${params.IsMisc}&ZoneValues=${params.ZoneValues}&shipid=${params.shipid}`
        `/Reports/InspectionByFindings`,
        {
          params: {
            ...params,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  //Dashboard APIs

  async fetchMonthlyStatistics() {
    try {
      let response = await AxiosInstance.get(`/Reports/MonthlyStatistics`);

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchSeverityChartData(params) {
    try {
      let response = await AxiosInstance.get(`Reports/GetInspectionBySeverityForChart`, {
        params: {
          ...params,
        },
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
  async fetchFindingsChartData(params) {
    try {
      let response = await AxiosInstance.get(`Reports/GetInspectionByFindingsForChart`, {
        params: {
          ...params,
        },
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchSeverityListData(params) {
    try {
      let response = await AxiosInstance.get(`Reports/GetInspectionBySeverityForList`, {
        params: {
          ...params,
        },
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchReportDocs(param: object, type: string) {
    try {
      const response = await AxiosInstance.get(`/Reports/${type}`, {
        params: param,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  },

  async fetchDataForHeatMap() {
    try {
      let response = await AxiosInstance.get('/ships/heatmap');

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async getChartForReportPDF(param) {
    try {
      const response = await AxiosInstance.post('/ExportPDF/GetChart', {
        ...param,
      });

      if (response.status === 200) {
        return response;
      }
    } catch (e) {
      return e;
    }
  },

  async DownloadExcelAndPDF(params, type) {
    try {
      let endpoint = '';
      if (type === 'ExportPDF') endpoint = `/${type}/Downlaod`;
      else endpoint = `/Reports/${type}`;

      var response = null;
      response = await AxiosInstance.get(endpoint, {
        params: {
          ...params,
        },
        responseType: 'blob',
      });

      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      return e;
    }
  },

  async fetchActivityLogs() {
    try {
      let response = await AxiosInstance.get('/activity/list');

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },

  async fetchLastUsedShip() {
    try {
      let response = await AxiosInstance.get('/ships/lastship');

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return error.response.data;
    }
  },
};
